module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Right-16a589ac74a768bc457b9066f1d9c857.svg";